import React from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchEmployeeCategory } from "services/employee";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { replaceUnderscoresWithSpaces } from "utils";

const EmployeeCategory = ({ errors, control, setValue, getValues, watch, required }) => {
  const key = "employee_category_id";
  const selected = watch(key);
  const value = getValues()[key];
  const { data, isLoading, error } = useQuery(
    ["employee-category-dropdown"],
    fetchEmployeeCategory,
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );



  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading employee categories</div>;

  const options =
    data?.data?.data?.map((item) => ({
      value: item.id,
      label: item.employee_category,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selected || option.value === value
  );

  return (
    <Controller
      name={key}
      control={control}
      rules={{
        required: required ? "Employee Category is required" : false,
        validate: (value) => {
          if (required && !value) return "Employee Category is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder={`Select ${replaceUnderscoresWithSpaces(
            "Employee Category"
          )}`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue(key, value);
          }}
          className={`react-select-container ${errors[key] ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default EmployeeCategory;
